import axios from 'axios';

const BASE_URL = 'https://brasilapi.com.br/api/banks/v1';

export type Bank = {
  ispb: string;
  code: number;
  name: string;
};

export const GetAllBanks = async () => {
  const url = `${BASE_URL}`;
  return (await axios.get(url).then((response) => response.data)) as Bank[];
};
